import { BaseService } from "@kiddocare-platform/portal-common/base";

export class RepositoryDocumentsService extends BaseService {
  
  public async GetDocument(key: string): Promise<Blob> {
    try {
      const response = await this.AxiosInstance.get(`/parent/documents/${key}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  public async GetPatientDocument(idPatient: bigint, key: string): Promise<Blob> {
    try {
      const response = await this.AxiosInstance.get(`/parent/documents/patient/${idPatient}/${key}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  public async UploadAccountDocument(type: string, front: Blob, back: Blob): Promise<any> {
    try {

      const imgBody = new FormData();
      imgBody.append("documentFront", front);
      imgBody.append("documentBack", back);

      const response = await this.AxiosInstance.post(`/parent/documents/${type}`, imgBody, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "multipart/form-data"
        }
      });
      return response.data;
    } catch (error: any) {
      this.log.error("uploadDocuments", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async UploadAccountDocumentPatient(idPatient: bigint, type: string, front: Blob, back: Blob): Promise<any> {
    try {

      const imgBody = new FormData();
      imgBody.append("documentFront", front);
      imgBody.append("documentBack", back);

      const response = await this.AxiosInstance.post(`/parent/documents/patient/${idPatient}/${type}`, imgBody, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "multipart/form-data"
        }
      });
      return response.data;
    } catch (error: any) {
      this.log.error("uploadDocuments", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}
